import { styled } from "@mui/material/styles";

export const ElseBox = styled("div")<{ boxPosition: "bottom" | "middle" }>(({ theme }) => ({
  border: `var(--tree-lines-width, 2px) solid ${theme.palette.info.dark}`,
  backgroundColor: theme.palette.info.main,
  color: theme.palette.common.white,
  borderRadius: "4px !important",
  position: "absolute",
  padding: theme.spacing(0, 0.5),
  lineHeight: 1,
  zIndex: 1,
  transform: "translate(-50%, 50%)",
  bottom: 0,
  left: "calc(-1 * var(--if-else-line-offset) + var(--tree-lines-width, 2px) * 4)",
}));
